<!-- intro-block-->
<div id="intro-block">
    <img
        src="/assets/images/mainpic-300.jpg"
        srcset="
            /assets/images/mainpic-300.jpg 300w,
            /assets/images/mainpic-600.jpg 600w,
            /assets/images/mainpic.jpg     960w"
        sizes="(max-width: 600px) min(calc(100vw - 32px), 430px), 300px"
        alt="Stephen Fluin"
        class="padded"
        width="960"
        height="960"
        loading="eager"
        decoding="async"
        fetchpriority="high"
    />
    <div class="intro-text">
        <h1>Stephen Fluin</h1>
        <p class="tagline">I help developers ship faster.</p>
        <p>
            I'm Head of DevRel at <a href="https://buildkite.com">Buildkite</a>, a former Angular core team member,
            and a current Angular GDE. I believe that with the right tools, and by staying in front of the wave of AI
            innovation, everyone can be more effective.
        </p>
        <p>
            I build and run my own <a routerLink="/projects">apps</a> end to end with AI coding agents, and share what
            worked, what broke, and why.
        </p>
    </div>
</div>
<!-- end intro-block-->

<hr />
<post-list [limit]="12"></post-list>
<p class="view-all"><a routerLink="/blog">View all posts →</a></p>
